import { toast } from 'react-toastify';

export function toastError(message: string) {
  toast.error(message, { position: 'top-right', autoClose: 4000 });
}

export function toastSuccess(message: string) {
  toast.success(message, { position: 'top-right', autoClose: 2500 });
}

export function toastInfo(message: string) {
  toast.info(message, { position: 'top-right', autoClose: 3000 });
}

/** Extract a human-readable error string from an axios error or plain Error. */
export function extractErrorMessage(err: unknown, fallback = 'Что-то пошло не так'): string {
  if (!err) return fallback;
  const e = err as any;
  return e?.response?.data?.error || e?.message || fallback;
}
